import React from 'react';
import img from './../Assets/Dv_profile.png';
const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-img">
        <div className="outer2">
          <span></span>
          <span></span>
          <img className="img" src={img} alt="Dipanshu" />
        </div>
      </div>
      <div className="about-text">
        <h2>About <span>Me</span></h2>
        <h4>Full Stack Web Developer</h4>
        <p>
        I'm Dipanshu Verma, a Full Stack Web Developer with a strong passion for building scalable and user-friendly applications. Skilled in both front-end and back-end development, with a focus on performance optimization, clean code, and efficient design patterns. Adept at solving complex problems and working collaboratively within a team environment to deliver high-quality software solutions. With hands-on experience of 3 months as a full-stack developer, I have developed a solid foundation in modern web technologies, including HTML, CSS, JavaScript, React, Node.js, and Express. My commitment to continuous learning drives me to stay updated with the latest industry trends and best practices, ensuring that my contributions are both innovative and effective. A dedicated professional eager to grow my skills further and make a meaningful impact in the field of web development.
        </p>
        <a download="Dipanshu-Verma-Resume.pdf" href={require("./../Assets/Dipanshu-Verma-Resume.pdf.pdf")} className="btn-box">
       Download CV
         </a>
      </div>
    </section>
  );
}

export default About;
